import(/* webpackMode: "eager", webpackExports: ["TeamsListSkeleton"] */ "/app/code/apps/web/app/(use-page-wrapper)/(main-nav)/teams/skeleton.tsx");
